import React from 'react';
const IconNavBell = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.72 8.9C6.93 6.15 9.25 4 12 4C14.75 4 17.07 6.15 17.28 8.9L17.79 15.73L18.86 17H2.53L2.5 17.04V19H9.5C9.5 20.38 10.62 21.5 12 21.5C13.38 21.5 14.5 20.38 14.5 19H21.5V17.04L19.73 14.94L19.27 8.75C18.99 4.96 15.79 2 12 2C8.21 2 5.01 4.96 4.73 8.75L4.27 14.94L4.21 15H6.26L6.72 8.9Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavBell;